import axios from "axios";
import { Contact } from "../data/contact";

export type FormApiResponse = {
    success: boolean;
    data?: string;
    error?: any;
};

export const submitForm = async (formData: Contact): Promise<FormApiResponse> => {
    const url: string = process.env.REACT_APP_CONTACT_FORM_URL || "http://localhost:5000/contact";
    try {
        const response = await axios.post(url, formData, {
            headers: { "Content-Type": "application/json" },
        });
        return { success: true, data: response.data };
    } catch (error) {
        console.error(error);
        return { success: false, error: "An unexpected error occurred" };
    }
};

export const submitNewsletterSignup = async (email: string): Promise<FormApiResponse> => {
    const url: string = process.env.REACT_APP_NEWSLETTER_URL || "http://localhost:5000/newsletter";
    try {
        const response = await axios.post(url, { email }, {
            headers: { "Content-Type": "application/json" },
        });
        return { success: true, data: response.data };
    } catch (error) {
        console.error(error);
        return { success: false, error: "An unexpected error occurred" };
    }
};
